// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d0d42f3b","628":"231388fb","828":"329eb34e","931":"80ebffbb"}[chunkId] + ".chunk.js";
};